import { Algorithm } from '../../../shared/dtos/algorithm';
import { itiMessageService } from '@/iti-core-vue';
import { Component, Vue } from 'vue-property-decorator';
import algorithmModule from '@/store/modules/algorithm.module'
import { ItiIconButton, ItiVHeader } from '@/iti-core-vuetify';
import { AlgorithmLaunchType } from '@/shared/enums/LaunchType';



@Component({
    components: {
        ItiIconButton,
    },
})

export default class AlgorithmList extends Vue {
    public loading = false;
    public search = '';


    public get algorithmList() {
        var algorithms = algorithmModule.algorithms
        algorithms.forEach(element => {
            element.launchTypeName = AlgorithmLaunchType[element.launchType.valueOf()].toString();
        });
        return algorithms;
    }

    public get headers() {
        return [
            new ItiVHeader('code', 'algoritmo.codigo'),
            new ItiVHeader('description', 'algoritmo.descripcion'),
            new ItiVHeader('dockerImage', 'algoritmo.imagen'),
            new ItiVHeader('state', 'algoritmo.estado'),
            new ItiVHeader('registered', 'algoritmo.registrado'),
            new ItiVHeader('imageEntryPoint', 'algoritmo.punto-entrada'),
            // new ItiVHeader('environmentVariables', 'algoritmo.variables-entorno'),
            new ItiVHeader('moduleName', 'algoritmo.nombre-modulo'),
            // new ItiVHeader('input', 'algoritmo.entrada'),
            // new ItiVHeader('output', 'algoritmo.salida'),
            // new ItiVHeader('containerSlots', 'algoritmo.slots'),
            // new ItiVHeader('categories', 'algoritmo.categorias'),
            new ItiVHeader('launchTypeName', 'algoritmo.tipo-lanzamiento'),
            new ItiVHeader('action', '').withWidth(50),
        ];
    }

    public mounted() {
        algorithmModule.getAlgorithms().catch(() => { itiMessageService.toast(this.$tc('mensajes-algoritmos.info-error'), 'error', 2000); });
    }
    public newItem() {
        algorithmModule.newAlgorithm();
        algorithmModule.setAlgorithmEditMode(false);
        this.$router.push({ name: 'AlgoritmoFormulario', params: { id: '0' } })
    }
    public launchAlgorithms(){
        algorithmModule.launchAlgorithms();
    }
    public register(algorithm: Algorithm) {
        algorithmModule.register(algorithm);
    }
    public unregister(algorithm: Algorithm) {
        algorithmModule.unregister(algorithm);
    }
    public activate(algorithm: Algorithm) {
        algorithmModule.activate(algorithm);
    }
    public deactivate(algorithm: Algorithm) {
        algorithmModule.deactivate(algorithm);
    }

    public deleteItem(algorithm: Algorithm) {
        itiMessageService.confirm(this.$tc('mensajes-algoritmos.pregunta-borrar-algoritmo'), this.$tc('mensajes.confirmar'), (res) => {
            if (res) {
                algorithmModule.getAlgorithmById(algorithm.id).then(() => {
                    algorithmModule.deleteAlgorithm(algorithm)
                        .then(() => {
                            itiMessageService.toast(this.$tc('mensajes-algoritmos.info-eliminar'), 'success', 3000);
                        })
                        .catch(() => {
                            itiMessageService.toast(this.$tc('mensajes-algoritmos.info-error'), 'error', 2000);
                        });

                })
            }
        });
    }

    public editItem(algorithm: Algorithm) {
        algorithmModule.getAlgorithmById(algorithm.id);
        algorithmModule.setAlgorithmEditMode(true);
        this.$router.push({ name: 'AlgoritmoFormulario', params: { id: algorithm.id.toString() } })
    }

    public formattedContent(contenido: string) {
        if (contenido && contenido.length > 40) {
            return String(contenido).substring(0, 40) + "...";
        } else {
            return contenido;
        }
    }

    public translateState(active:boolean) {      
        return this.$tc(active.toString());
    }

    public translateLaunchTypeName(launchType:any) {   
        return this.$tc('enum-launch-type.'+launchType.toString());
    }
}